import React from 'react'
import { Route, Switch } from 'react-router-dom'

import { URL_CONST } from 'utils/urlConsts'

import LoginFlow from 'containers/Login/LoginFlow'

require('components/styles/layouts/login.styl')

export default class Login extends React.Component {
  render() {
    return (
      <div className="hide-preloader-animated login">
        <div className="login-content">
          <img
            className="logo"
            src="/static/webapp/img/signin-ironscales-logo.svg"
            alt="IRONSCALES"
          />
          <Switch>
            <Route path={URL_CONST.login.signin} exact component={LoginFlow} />
          </Switch>
        </div>
      </div>
    )
  }
}
